import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './WithdrawalVerify.css';

const WithdrawalVerify: React.FC = () => {
  const [code, setCode] = useState(['', '', '', '', '', '']);

  const handleCodeChange = (index: number, value: string) => {
    if (value.length <= 1) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);

      if (value && index < 5) {
        const nextInput = document.getElementById(`code-input-${index + 1}`);
        nextInput?.focus();
      }
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      const prevInput = document.getElementById(`code-input-${index - 1}`);
      prevInput?.focus();
    }
  };

  return (
    <div className="app-container">
      <div className="mobile-frame">
        <div className="mobile-notch"></div>
        <div className="mobile-screen">
          <div className="withdrawal-verify">
            <div className="withdrawal-verify-header">
              <Link to="/withdrawal-confirm" className="withdrawal-verify-back">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
              <h1 className="withdrawal-verify-title">Verify 2FA</h1>
            </div>

            <div className="withdrawal-verify-overlay">
              <div className="withdrawal-verify-modal">
                <h2 className="withdrawal-verify-heading">One Time Passcode</h2>
                <p className="withdrawal-verify-description">
                  Please enter the 6 digit code sent to your Email
                </p>

                <div className="withdrawal-verify-code-inputs">
                  {code.map((digit, index) => (
                    <input
                      key={index}
                      id={`code-input-${index}`}
                      type="text"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleCodeChange(index, e.target.value)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      className="withdrawal-verify-code-input"
                    />
                  ))}
                </div>

                <Link to="/withdrawal-success" className="withdrawal-verify-btn">
                  Verify Transfer
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawalVerify;